import { ActionItemId, Dtos, type Relations } from "@inrev/common";
import { match } from "ts-pattern";
import { ActionItem } from "./types";

export const adminActionItemsQueryKey = {
	all: () => ["admin", "actionItems"] as const,
	actionItemsByRelation: (relation: Relations.ActionItems) =>
		["admin", "actionItems", relation.relationType, relation.relationId] as const,
};

export const toRelation = (actionItem: Relations.ActionItems): Relations.ActionItems =>
	match(actionItem)
		.with({ relationType: "account" }, ({ relationType, relationId }) => ({
			relationType,
			relationId,
		}))
		.with({ relationType: "bond" }, ({ relationType, relationId }) => ({
			relationType,
			relationId,
		}))
		.with({ relationType: "quote" }, ({ relationType, relationId }) => ({
			relationType,
			relationId,
		}))
		.exhaustive();

export type ActionItemByIdMap = Record<ActionItemId, ActionItem>;

export const transformActionItems = (
	actionItems: Dtos.ActionItem.Get.Response[],
): ActionItemByIdMap =>
	Object.fromEntries(
		actionItems.map((actionItem) => {
			return [actionItem.id, transformActionItem(actionItem)];
		}),
	);

export const transformActionItem = (actionItem: Dtos.ActionItem.Get.Response): ActionItem => {
	return Dtos.ActionItem.Get.Response.schema.parse(actionItem);
};
